import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'


export const SC_StepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  margin-bottom: 16px;
  padding-right: 48px;
`

export const SC_Step = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  div {
    width: 40px;
    height: 40px;
    background-color: ${E_Colors.MainColorAccent};
    border-radius: 50%;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const SC_VertLine = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${E_Colors.GrayB7BEBE};
  margin: 4px 0 4px 20px;
`
